import * as InfoBarActionTypes from '../actiontypes/infoBar';


const initialState = {
  isFetching: false,
  error: false,
  snippets: [],
};


/**
 * InfoBar Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
const InfoBar = (state = initialState, action) => {
  const { payload = {} } = action;

  switch (action.type) {
    case InfoBarActionTypes.FETCH_SNIPPETS_SUCCESS:
      return {
        ...state,
        snippets: [...state.snippets, ...payload.snippets],
      };

    case InfoBarActionTypes.SUPPORTING_DATA_SUCCESS:
      return {
        ...state,
        advert: payload.advert,
        snippets: payload.snippets,
      };

    default:
      return state;
  }
};

export default InfoBar;